import auth from "../store/modules/auth";

import { log2 } from "../utils/log2";
import { distinct, filter, map } from "rxjs/operators";
import { interval } from "rxjs";
import router from "../router";
import * as _ from "lodash";

const log = log2("titleUpdater");

export const startUserPermissionValidator = () => {
    interval(500)
        .pipe(
            map((x) => router.currentRoute.path),
            distinct((x) => x),
            filter((x) => auth.state.user)
        )
        .subscribe((x) => {
            const currentRoute = router.currentRoute;
            const u = auth.state.user;
            log("StartUserPermissionValidator", currentRoute);

            if (u && u.role && !u.role.isRoot && _.get(currentRoute, "meta.permission")) {
                if (Array.isArray(currentRoute.meta.permission)) {
                    if (!u.role.permissions.some((x) => currentRoute.meta.permission.includes(x.name))) {
                        log("denied forwaring 1");
                        return router.push("/denied");
                    }
                } else {
                    if (!currentRoute.meta.permission) {
                        return;
                    }
                    if (!u.role.permissions.some((x) => x.name === currentRoute.meta.permission)) {
                        log("denied forwaring 2");
                        return router.push("/denied");
                    }
                }
            }
        });
};
